// @flow

import React, { PureComponent } from 'react';
import wNumb from 'wnumb';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { dispatch } from '@ro-store';
import ControlItem from '@ro-components/ControlItem';
import { UiSlider } from '@ro-atoms/Slider';

import { AnimationContainer, AnimationSlider } from './AnimationSwitch.styles';

const setAnimation = animation => dispatch.ro.setAnimation(animation);
const durationChange = duration => dispatch.ro.setDuration(550 - duration);

class AnimationSwitch extends PureComponent {
  render() {
    const { t, animation, color, animationSpeed } = this.props;

    return (
      <AnimationContainer>
        {animation && (
          <AnimationSlider>
            <UiSlider
              options={{
                range: { min: 50, max: 500 },
                step: 50,
                animate: false,
                start: [550 - animationSpeed || 50],
                tooltips: [
                  wNumb({
                    decimals: 0,
                    prefix: '1kl / ',
                    suffix: 'ms',
                    encoder: function(a) {
                      return 550 - a;
                    }
                  })
                ]
              }}
              values={[550 - animationSpeed]}
              onChange={e => durationChange(e)}
            />
          </AnimationSlider>
        )}
        <ControlItem
          tooltip={animation ? t(`titles.animation.disable`) : t(`titles.animation.enable`)}
          onClick={e => setAnimation(!animation)}
          icon={animation ? t(`icons.controls.animation.stop`) : t(`icons.controls.animation.play`)}
          color={color}
        />
      </AnimationContainer>
    );
  }
}

const mapStateToProps = state => ({
  color: state.ro.color,
  animation: state.ro.animation,
  animationSpeed: state.ro.userSettings.animationSpeed
});

export default connect(mapStateToProps)(translate('common')(AnimationSwitch));
